// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2o10B","addWidgetButton":"Header_addWidgetButton__uS3eg","dashboardTabs":"Header_dashboardTabs__3Soc8","active":"Header_active__1hS07"};